module.exports = [{
      plugin: require('/opt/build/repo/gatsby-site/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":750,"linkImagesToOriginal":false},
    }]
